module.exports = __webpack_public_path__ + "img/my-pools-red@2x.a587260f.png";